import { Injectable } from '@angular/core';
import { StorageType } from '../storage-service/storage.service';

const URL = 'base_url';
const REPORT_URL = 'report_url';

@Injectable({ providedIn: 'root' })
export class URLService {
    private storage: Storage = localStorage; // Default to localStorage

    getURL(): string {
        let result = sessionStorage.getItem(URL);
        if (result === null) {
            result = localStorage.getItem(URL);
        }
        return result ?? '';
    }

    saveURL(url: string): void {
        this.storage.setItem(URL, url);
    }

    removeURL(): void {
        this.storage.removeItem(URL);
        this.storage.removeItem(REPORT_URL);
    }

    getReportURL(): string {
        let result = sessionStorage.getItem(REPORT_URL);
        if (result === null) {
            result = localStorage.getItem(REPORT_URL);
        }
        return result ?? '';
    }

    saveReportURL(url: string): void {
        this.storage.setItem(REPORT_URL, url);
    }

    setStorageType(type: StorageType): void {
        this.storage = type === StorageType.SESSION ? sessionStorage : localStorage;
    }
}
